import type { User } from '@auth0/auth0-react';
import type {
  Integration,
  ProviderType,
} from 'src/api/endpoints/cloudApi.types';
import { userHelpers } from 'src/utils/userHelpers';

export const STORAGE_INTEGRATION_LIMIT = 5;
export const MESSAGING_INTEGRATION_LIMIT = 1;
export const CALENDAR_INTEGRATION_LIMIT = 3;

export const integrationLimits: Record<ProviderType, number> = {
  Storage: STORAGE_INTEGRATION_LIMIT,
  Messaging: MESSAGING_INTEGRATION_LIMIT,
  Calendar: CALENDAR_INTEGRATION_LIMIT,
};

export const isMaxIntegrations = (options: {
  providerType: ProviderType;
  integrations: Integration[] | null | undefined;
  user: User | null | undefined;
}) => {
  if (userHelpers.isRemarkableUser(options.user)) {
    return false; // reMarkable users are not subject to integration limits
  }
  const maxIntegrations = integrationLimits[options.providerType];

  console.assert(
    maxIntegrations !== undefined,
    `No integration limit defined for provider type: ${options.providerType}`
  );

  const matchingIntegrations =
    options.integrations?.filter(
      (i) => i.providerType === options.providerType
    ) ?? [];

  return matchingIntegrations.length >= maxIntegrations;
};
